<div class="bell-wrap" [class.open]="menuOpen()">
  <button
    class="ghead-ibtn"
    type="button"
    [attr.aria-label]="unreadCount() > 0 ? ('NOTIF.ARIA_UNREAD' | translate: { count: unreadCount() }) : ('NOTIF.ARIA' | translate)"
    aria-haspopup="true"
    [attr.aria-expanded]="menuOpen()"
    (click)="toggleMenu()"
    data-testid="bell-button"
  >
    <i class="ls-bell"></i>
    @if (unreadCount() > 0) {
      <span class="ghead-count" data-testid="bell-count">{{ unreadCount() > 99 ? '99+' : unreadCount() }}</span>
    }
  </button>

  <div class="ghead-pop ghead-bell-pop" role="menu" data-testid="bell-menu" (click)="$event.stopPropagation()">
    <div class="ghead-bell-head">
      <strong>{{ 'NOTIF.TITLE' | translate }}</strong>
      @if (liveConnected()) {
        <span class="ghead-live" [title]="'NOTIF.LIVE_TITLE' | translate" data-testid="bell-live">{{ 'NOTIF.LIVE' | translate }}</span>
      }
      @if (unreadCount() > 0) {
        <button type="button" class="ghead-bell-all" (click)="markAllRead()" data-testid="bell-mark-all">{{ 'NOTIF.MARK_ALL' | translate }}</button>
      }
    </div>

    @if (recent().length === 0) {
      <p class="ghead-bell-empty" data-testid="bell-empty">{{ 'NOTIF.EMPTY' | translate }}</p>
    } @else {
      <ul class="ghead-bell-list">
        @for (item of recent(); track item.id) {
          <li>
            <button type="button" [class.unread]="!item.isRead" (click)="open(item)" [attr.data-testid]="'bell-item-' + item.id">
              <span class="ghead-bell-dot" aria-hidden="true"></span>
              <span class="ghead-bell-body">
                <span class="ghead-bell-title">{{ text(item).title }}</span>
                <span class="ghead-bell-msg">{{ text(item).message }}</span>
                <span class="ghead-bell-meta">{{ typeLabel(item.type) }} · {{ timeAgo(item.createdAt) }}</span>
              </span>
            </button>
          </li>
        }
      </ul>
    }
  </div>
</div>

<!-- Toast : notification reçue en direct -->
@if (pushed(); as toast) {
  <div class="ghead-toast" role="status" data-testid="notification-toast">
    <button type="button" class="ghead-toast-main" (click)="open(toast)">
      <i class="ls-bell"></i>
      <span>
        <strong>{{ text(toast).title }}</strong>
        <span>{{ text(toast).message }}</span>
      </span>
    </button>
    <button type="button" class="ghead-toast-close" [attr.aria-label]="'NOTIF.CLOSE' | translate" (click)="closeToast()">
      <i class="ls-x"></i>
    </button>
  </div>
}
